import * as React from 'react';
import * as styled from './styled';
import {useFormikContext} from 'formik';
import {ProgramItem, ProgramObject, ProgramType, FoodItem} from 'api/program/types';
import {RecipeObject} from 'api/recipe/types';
import Row from 'components/Row';
import Column from 'components/Column';
import {InstanceSelectVariant} from 'components/InstanceSelect';
import {SelectRecipe} from 'components/SelectRecipe';
import {Recipe} from './components/Recipe';

/**
 * The content of gym builder.
 * @return {React.ReactElement}
 * @constructor
 */
export default function Content(): React.ReactElement {
  const {
    values, setFieldValue,
  } = useFormikContext<Partial<ProgramObject<FoodItem>>>();

  const recipes: ProgramItem<FoodItem>[]
    = values?.days ? values?.days[0] ? values?.days[0].items : [] : [];

  /**
   * Render stage.
   * @param {FoodItem["itemType"]} itemType
   * @param {string} title
   * @return {JSX.Element}
   */
  function renderStage(
      itemType: FoodItem['itemType'],
      title: string,
  ): JSX.Element {
    /**
     * Render recipes.
     * @return {JSX.Element}
     */
    function renderRecipes(): JSX.Element {
      /**
       * Render recipe.
       * @param {ProgramItem<FoodItem>} item
       * @param {number} index
       * @return {JSX.Element}
       */
      function renderRecipe(
        item: ProgramItem<FoodItem>,
        index: number,
      ): JSX.Element {
        return (
          <Row key={index}>
            <Column>
              <Recipe
                {...item}
                index={index}
              />
            </Column>
          </Row>
        );
      }

      return (
        <React.Fragment>
          {recipes?.filter((item) => (
            item.itemType === itemType
          )).map((item, index) => (
            renderRecipe(item, index)
          ))}
        </React.Fragment>
      );
    }

    /**
     * Render select.
     * @return {JSX.Element}
     */
    function renderSelect(): JSX.Element {
      /**
       * The select event handler.
       * @return {void}
       */
      function handleSelect(recipe: RecipeObject): void {
        setFieldValue('days[0].items', [
          ...recipes,
          {
            id: recipe.id,
            type: ProgramType.Recipe,
            itemType,
          },
        ]);
      }

      return (
        <Row>
          <Column>
            <SelectRecipe
              variant={InstanceSelectVariant.Accent}
              onSelect={handleSelect}
            />
          </Column>
        </Row>
      );
    }

    return (
      <styled.Stage>
        <Row>
          <Column>
            <styled.Title>
              {title}
            </styled.Title>
          </Column>
        </Row>
        {renderRecipes()}
        {renderSelect()}
      </styled.Stage>
    );
  }

  return (
    <styled.Wrapper>
      {renderStage('breakfast', 'Завтрак')}
      {renderStage('lunch', 'Обед')}
      {renderStage('dinner', 'Ужин')}
      {renderStage('snack', 'Перекус')}
    </styled.Wrapper>
  );
}
